import withSideEffect from 'react-side-effect';

const Fragment = ({ children }) => children;

function reducePropsToState(propsList) {
  return propsList.map(({ className }) => className);
}
let originalClassName = null;
function handleStateChangeOnClient(className) {
  if (originalClassName === null) {
    originalClassName = document.body.className || '';
  }
  if (className.length) {
    const nextClassName = [originalClassName, ...className]
      .filter(Boolean)
      .join(' ');
    if (document.body.className !== nextClassName) {
      document.body.className = nextClassName;
    }
    return;
  }
  document.body.className = originalClassName;
}

export default withSideEffect(
  reducePropsToState,
  handleStateChangeOnClient,
)(Fragment);
